import React, {Component} from 'react';
import Swiper from 'react-id-swiper';
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';

class Howdoesthis extends Component {
    constructor(props) {
        super(props)
        this.state = {
            screen: 1,
        }
    }

    componentDidMount() {
        this.initializeReactGA();
        var img = 1;
        setInterval(() => {
            img = img + 1;
            if (img == 4) {
                img = 1
            }
            this.setState({screen: img});
        }, 5000)
    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/how_does_this_app_works');
    }

    render() {

        const params = {
            loop: true,
            slidesPerView: 1,
            autoplay: {delay: 5000},
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                slideChangeTransitionStart: () => {
                    console.log('sdf',)
                },
            }
        }


        return (
            <div className="doesappwork pdtb-20">
                <MetaTags>
                    <title>Revfin</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>
                <section className="app_work" id="app_work">
                    <div className="container">
                        <div className="row">
                            <h3 className="heading_tow">Download our App to apply for a loan</h3>
                            <h3 className="full-w text-center color_main fz-20">How the app works</h3>
                            <div className="col-lg-6 col-md-4 col-xs-12 col-sm-12">
                                <figure className="app_work_images">
                                    <img src={require(`../images/appwork_${this.state.screen}.png`)}/>
                                </figure>
                            </div>
                            <div className="col-lg-6 col-md-8 col-xs-12 col-sm-12">
                                <div className="d-block mysmallSlider">
                                    <Swiper {...params} >
                                        <div>
                                            <li className="xs-slider">
                                                <a href="javascript:void(0)" className="rev_media">
                                                    <div className="media_left"><i className="one-sp"></i></div>
                                                    <div className="contentarea">
                                                        <b className="fz-17 fw3 revfincolor">Apply</b>
                                                        <p className="mgt-10 fz-12 lcolor">Download our App to complete
                                                            the application process.
                                                            From starting to getting a decision usually takes about
                                                            10 minutes!</p>
                                                    </div>
                                                </a>
                                            </li>
                                        </div>

                                        <div>
                                            <li>
                                                <a href="javascript:void(0)" className="rev_media">
                                                    <div className="media_left"><i className="two-sp"></i></div>
                                                    <div className="contentarea">
                                                        <b className="fz-17 fw3 revfincolor">Select</b>
                                                        <p className="mgt-10 fz-12 lcolor">Select the loan that next
                                                            suits your need. Get an additional
                                                            Revloan credit line.</p>
                                                    </div>
                                                </a>
                                            </li>
                                        </div>

                                        <div>
                                            <li>
                                                <a href="javascript:void(0)" className="rev_media">
                                                    <div className="media_left"><i className="three-sp"></i></div>
                                                    <div className="contentarea">
                                                        <b className="fz-17 fw3 revfincolor">Spend</b>
                                                        <p className="mgt-10 fz-12 lcolor">Get money in your account
                                                            within minutes, so start
                                                            spending!</p>
                                                    </div>
                                                </a>
                                            </li>
                                        </div>
                                    </Swiper>
                                </div>
                            </div>


                        </div>
                    </div>
                </section>


            </div>
        )
    }
}


export default Howdoesthis



// WEBPACK FOOTER //
// ./src/components/how_does_this_app_works.js